// Theme configuration for styled-components
export const theme = {
  // Breakpoints (converted from SCSS variables)
  breakpoints: {
    mobileLandscape: '420px',
    mobile: '768px',
    tablet: '769px',
    desktop: '1000px',
    widescreen: '1192px',
    fullhd: '1384px',
  },

  // Borders
  borderRadius: '4px',

  // Animation
  transitionDuration: '0.2s',

  // Colors
  colors: {
    white: '#ffffff',
    border: '#efefef',
    text: '#888888',
    link: 'rgba(0, 0, 255, 0.63)',
    linkHover: 'rgba(0, 0, 255, 0.8)',
    shadow: 'rgba(0, 0, 0, 0.08)',
    shadowTablet: 'rgba(0, 0, 0, 0.08)',
  },
};

// Media query helpers (converted from SCSS mixins)
export const media = {
  mobile: `@media screen and (max-width: ${parseInt(theme.breakpoints.tablet) - 1}px)`,
  mobileLandscape: `@media screen and (min-width: ${theme.breakpoints.mobileLandscape})`,
  tablet: `@media screen and (min-width: ${theme.breakpoints.tablet}), print`,
  tabletOnly: `@media screen and (min-width: ${theme.breakpoints.tablet}) and (max-width: ${parseInt(theme.breakpoints.desktop) - 1}px)`,
  touch: `@media screen and (max-width: ${parseInt(theme.breakpoints.desktop) - 1}px)`,
  desktop: `@media screen and (min-width: ${theme.breakpoints.desktop})`,
  desktopOnly: `@media screen and (min-width: ${theme.breakpoints.desktop}) and (max-width: ${parseInt(theme.breakpoints.widescreen) - 1}px)`,
  untilWidescreen: `@media screen and (max-width: ${parseInt(theme.breakpoints.widescreen) - 1}px)`,
  widescreen: `@media screen and (min-width: ${theme.breakpoints.widescreen})`,
  widescreenOnly: `@media screen and (min-width: ${theme.breakpoints.widescreen}) and (max-width: ${parseInt(theme.breakpoints.fullhd) - 1}px)`,
  untilFullhd: `@media screen and (max-width: ${parseInt(theme.breakpoints.fullhd) - 1}px)`,
  fullhd: `@media screen and (min-width: ${theme.breakpoints.fullhd})`,
};

export type Theme = typeof theme;
